import {
  WithBadge
} from "./chunk.YZP3RYP4.js";
import {
  JbIntElementInit
} from "./chunk.62T75WFP.js";
import {
  __decorateClass
} from "./chunk.Y3TZ4FJV.js";

// src/components/icon-button/icon-button.ts
import { spreadProps } from "@open-wc/lit-helpers";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
var JbIntElement = JbIntElementInit();
var JbIntIconButton = class extends WithBadge(JbIntElement) {
  constructor() {
    super(...arguments);
    this.disableHoverEffects = false;
    this.icon = void 0;
    this.interactiveAnimation = void 0;
    this.link = void 0;
    this.tooltip = "";
    this._hovered = false;
  }
  /**
   * @returns Template of the icon component.
   */
  _renderIcon() {
    if (!this.icon || !this.icon.name) return nothing;
    return html`<jb-int-icon
      ${spreadProps({ ...this.icon })}
      .hovered=${this._hovered}
      class="h-[20px] text-inherit md:h-[24px]"
      part="icon"
    ></jb-int-icon>`;
  }
  /**
   * @returns Template of the interactive animation component.
   */
  _renderInteractiveAnimation() {
    if (!this.interactiveAnimation || !this.interactiveAnimation.animationFile) return nothing;
    return html`<jb-int-interactive-animation
      ${spreadProps({ ...this.interactiveAnimation })}
      .playing=${this._hovered}
      class="text-inherit"
      part="icon"
    ></jb-int-interactive-animation>`;
  }
  /**
   * Main render method of the component.
   * @returns Template of the icon as a clickable button.
   */
  render() {
    return html`
      <a
        ${spreadProps({ ...this.link })}
        class="${classMap({
      "md:hover:bg-white-10": !this.disableHoverEffects
    })} relative flex min-w-full cursor-pointer items-center justify-center transition-all duration-300 "
        title=${this.tooltip ?? ""}
        @mouseover=${() => this._hovered = true}
        @mouseleave=${() => this._hovered = false}
      >
        <span class="relative inline-flex items-center justify-center text-inherit">
          ${this._renderIcon()} ${this._renderInteractiveAnimation()}
        </span>
      </a>
    `;
  }
};
__decorateClass([
  property({ type: Boolean })
], JbIntIconButton.prototype, "disableHoverEffects", 2);
__decorateClass([
  property({ type: Object })
], JbIntIconButton.prototype, "icon", 2);
__decorateClass([
  property({ type: Object })
], JbIntIconButton.prototype, "interactiveAnimation", 2);
__decorateClass([
  property({ type: Object })
], JbIntIconButton.prototype, "link", 2);
__decorateClass([
  property()
], JbIntIconButton.prototype, "tooltip", 2);
__decorateClass([
  state()
], JbIntIconButton.prototype, "_hovered", 2);
JbIntIconButton = __decorateClass([
  customElement("jb-int-icon-button")
], JbIntIconButton);

export {
  JbIntIconButton
};
